import { useContractExtensions } from '@services/contracts/queires/useContractExtensions'
import { useContracts } from '@services/contracts/queires/useContracts'
import { format, parseISO } from 'date-fns'
import { useTranslation } from 'react-i18next'

import { cn } from '@/lib/utils'

const fmt = (d: string) => format(parseISO(d), 'dd.MM.yyyy')

/**
 * Who extended the offer's contract, when, from which end date to which, and
 * whether the clients were emailed the renewal notice. Renders nothing until
 * the contract has been extended at least once.
 */
export function ContractExtensionHistory(props: { offerId: string }) {
  const { offerId } = props
  const { t } = useTranslation('offers')
  const { data: contracts } = useContracts({
    params: { offer: offerId, type: 'offer' }
  })
  const contract = contracts?.results?.find((c) => c.status === 'completed')
  const { data: history } = useContractExtensions(contract?.id)

  if (!history?.length) return null

  return (
    <div className="w-full space-y-2">
      <div className="text-[11px] font-medium uppercase tracking-wide text-muted-foreground">
        {t('admin.actions.extension_history')}
      </div>
      <div className="space-y-1.5">
        {history.map((entry) => (
          <div
            key={entry.id}
            className="flex items-center justify-between gap-2 rounded-xl border border-ink/[0.06] bg-white px-3 py-2 text-sm"
          >
            <div className="min-w-0">
              <div className="font-semibold text-ink">
                {fmt(entry.previous_end_date)} → {fmt(entry.new_end_date)}
              </div>
              <div className="truncate text-xs text-muted-foreground">
                {format(parseISO(entry.created_at), 'dd.MM.yyyy HH:mm')}
                {entry.extended_by && ` · ${entry.extended_by}`}
              </div>
            </div>
            <span
              className={cn(
                'shrink-0 rounded-full px-2 py-0.5 text-xs font-semibold',
                entry.notified
                  ? 'bg-primary/10 text-primary'
                  : 'bg-ink/[0.06] text-muted-foreground'
              )}
            >
              {entry.notified
                ? t('admin.actions.extension_notified')
                : t('admin.actions.extension_not_notified')}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}
